import styles from "./pageLink.module.css";
import TextWrapper from "../textWrapper/TextWrapper";
import { NavLink } from "react-router-dom";

// iconOnly: show just the icon (collapsed sidebar); give it an `ariaLabel` so
// screen readers still name the page.
const PageLink = ({ image, icon: Icon, children, destination, iconOnly = false, ariaLabel }) => {
  return (
    <NavLink
      to={destination}
      aria-label={ariaLabel}
      className={({ isActive }) => {
        return isActive
          ? `${styles.container} ${styles.active}`
          : styles.container;
      }}
    >
      {!iconOnly && <TextWrapper textStyle="textXSmall">{children}</TextWrapper>}
      {Icon ? (
        <Icon className={styles.icon} />
      ) : image ? (
        <img src={image} alt="icon placeholder" />
      ) : null}
    </NavLink>
  );
};

export default PageLink;
